// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"787":"502900b9","897":"ffa3d64f"}[chunkId] + ".chunk.js";
};